<template>
  <section id="home-intro">
    <div class="container">
      <div class="row">

        <div class="col-sm-1 hidden-xs">&nbsp;</div>

        <div class="col-sm-3 hidden-xs">
          <img src="../../assets/img/logo/beer.png" alt="Foobar Beer" title="Foobar Beer">
        </div>

        <div class="col-sm-8 col-xs-12 content">
          <h2>Code &amp; foo_bar Blog</h2>
          <p><a href="#" v-scroll-to="'#footer'">by cubeek</a></p>
        </div>

      </div>
    </div>
  </section>

</template>

<script>
  import Clearfix from '../utils/Clearfix'

  export default {
    components: { Clearfix }
  }
</script>

<style>
  #home-intro {
    background: url('../../assets/img/bg/disk.jpeg') center fixed no-repeat;
    background-size: cover;
    filter: brightness(50%);
    height: 100%;

    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// IntroLarge.vue?7fabd46d